jQuery(document).ready(function ($) {
	/*
	 * Select list form
	 */

	// Toggle dropdown visibility
	$(".select-menu").on("click", function (e) {
		e.stopPropagation(); // Prevent click from propagating to document
		$(this).toggleClass("has-open-menu");
		const dropdown = $(this).siblings(".select-menu__dropdown");
		dropdown.toggleClass("visible");
	});

	// Mockup - Update select-menu text on item click.
	$(".select-menu__dropdown p").on("click", function () {
		const selectedText = $(this).text();
		$(this)
			.closest(".product-filter-block-select")
			.find(".select-menu")
			.text(selectedText);
		$(this).parent().removeClass("visible"); // Hide dropdown after selection
	});

	// Close dropdown when clicking outside
	$(document).on("click", function (e) {
		if (!$(e.target).closest(".product-filter-block-select").length) {
			$(".select-menu__dropdown").removeClass("visible");
		}
	});

	/*
	 * Search filter mockup
	 */

	// Show results-dropdown on focus and hide on blur
	// This may or may not be helpful for the WP Block build. It's more of a mockup
	// to show that it will have the same inline search functionality as the
	// current product filter.

	$(".search-container__search-input").on("focus", function () {
		$(this)
			.closest(".product-filter-block__content__search")
			.find(".results-dropdown")
			.addClass("visible");
	});

	$(".search-container__search-input").on("blur", function () {
		$(this)
			.closest(".product-filter-block__content__search")
			.find(".results-dropdown")
			.removeClass("visible");
	});
});
